import React, { useEffect, useState } from "react";

//*MUI
import { Box, Modal } from "@mui/material";
import CustomInput from "../../../Subcomponents/CustomInput";

//*files
import cssClasses from "./EditNbfcModal.module.css";
import Close from "../../Icons/Close";
import Button from "../../../Subcomponents/Button";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

function EditNbfcModal({
  open,
  handleClose,
  handleSave,
  selectedNbfcData,
  allNbfcList,
}) {
  const [nbfcData, setNbfcData] = useState({
    nbfcName: "",
  });
  const [nbfcList, setNbfcList] = useState([]);

  const [helperText, setHelperText] = useState({
    nbfcName: "",
  });

  useEffect(() => {
    if (selectedNbfcData !== null) {
      setNbfcData(selectedNbfcData);
      setNbfcList(allNbfcList);
    }
  }, [selectedNbfcData]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>
                    {"Edit NBFC Name"}
                  </Box>
                </Box>
              </Box>
              <Box
                ml={"auto"}
                mt={1}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                <Close width={"1.2rem"} height={"1.2rem"} />
              </Box>
            </Box>
          </Box>

          <Box width={"100%"} height={"49%"} overflow={"auto"}>
            <Box
              paddingX={"3rem"}
              backgroundColor={"#F9FAFB"}
              display={"flex"}
              justifyContent={"space-between"}
              gap={"2rem"}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3rem",
                  justifyContent: "space-evenly",
                  margin: "2rem 0rem",
                }}
              >
                <div>
                  <CustomInput
                    handleChange={(e) => {
                      setNbfcData((pre) => {
                        pre.nbfcName = e;
                        return { ...pre };
                      });
                      if (e && e !== "") {
                        setHelperText((pre) => {
                          pre.nbfcName = "";
                          return { ...pre };
                        });
                      }

                      if (
                        nbfcList?.findIndex((v) => v?.nbfcName === e) !== -1
                      ) {
                        setHelperText((pre) => {
                          pre.nbfcName = "This NBFC record already available!";
                          return { ...pre };
                        });
                      }
                      if (e === "") {
                        setHelperText((pre) => {
                          pre.nbfcName = "Please enter NBFC name!";
                          return { ...pre };
                        });
                      }else if (!e?.trim()?.length) {
                        setHelperText((pre) => {
                          pre.nbfcName = "NBFC name can not be empty!";
                          return { ...pre };
                        });
                      }else if (!/^[A-Za-z0-9 ]+$/.test(e)) {
                        setHelperText((pre) => {
                          pre.nbfcName = "NBFC name can not contain special characters!";
                          return { ...pre };
                        });
                      }else if (/\d/.test(e) === true) {
                        setHelperText((pre) => {
                          pre.nbfcName = "NBFC name can not contain numbers!";
                          return { ...pre };
                        });
                      }
                    }}
                    // label={'Parking Type'}
                    value={nbfcData?.nbfcName}
                    placeholder={"Enter NBFC name"}
                    inputType={"text"}
                    helperText={helperText?.nbfcName}
                  />
                </div>
              </div>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box
              className={cssClasses.flexRow}
              style={{ justifyContent: "end" }}
            >
              <Box width={"fit-Content"}>
                <Button
                  style={{
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                    color: "#FFF",
                    backgroundColor: "#006AFF",
                    borderRadius: "0.8rem",
                  }}
                  padding={"0.65rem 3.2rem"}
                  disable={helperText?.nbfcName !== ""}
                  btnName={"Save"}
                  clicked={() => {
                    handleSave(nbfcData);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default EditNbfcModal;
